<template>
  <div>
    <div
      style="color: #e90001; border-bottom: 1px solid #e90001"
      class="fr jc ac p10"
    >
      捐赠人/单位
    </div>
    <!-- 捐款意向 -->
    <van-cell-group class="mt20">
      <van-field
        required
        @click="jkyx_show = true"
        label="捐款意向"
        :value="submit_form.name"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />

      <van-popup v-model="jkyx_show" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="jkyx_picker"
          @cancel="jkyx_show = false"
          @confirm="
            (item, index) => {
              this.submit_form.jkyx_index = index
              this.submit_form.name = item.name
              this.jkyx_show = false
            }
          "
        />
      </van-popup>

      <!-- 捐款方式 -->
      <van-field
        required
        @click="jkfs_show = true"
        label="捐款方"
        v-model="jkfs_picker[submit_form.jkfs_index]"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />

      <van-popup v-model="jkfs_show" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="jkfs_picker"
          @cancel="jkfs_show = false"
          @confirm="
            (item, index) => {
              this.submit_form.jkfs_index = index
              this.jkfs_show = false
            }
          "
        />
      </van-popup>

      <!-- 捐款金额 -->
      <van-field
        required
        @click="jkje_show = true"
        label="捐款金额"
        :value="jkje_picker[submit_form.jkje_index]"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />
      <van-popup v-model="jkje_show" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="jkje_picker"
          @cancel="jkje_show = false"
          @confirm="
            (item, index) => {
              this.submit_form.jkje_index = index
              this.jkje_show = false
              if (index == 0) {
                this.submit_form.money = 5
              }
              if (index == 1) {
                this.submit_form.money = 10
              }
              if (index == 2) {
                this.submit_form.money = 50
              }
              if (index == 3) {
                this.submit_form.money = ''
              }
            }
          "
        ></van-picker>
      </van-popup>

      <!-- 其他金额 -->
      <van-field
        @input="onMoneyInput"
        v-if="submit_form.jkje_index == 3"
        v-model="submit_form.money"
        placeholder="0.01-不限"
        type="number"
        input-align="right"
      >
        <template slot="label">
          <div>其他金额</div>
        </template>
      </van-field>
      <div v-if="submit_form.jkje_index == 3" class="pl16 pb10 fz12">
        个人满200,单位满1000元可打印纸质证书
      </div>

      <van-field
        v-if="
          (submit_form.jkfs_index == 0 && submit_form.money >= 200) ||
          (submit_form.jkfs_index == 1 && submit_form.money >= 1000)
        "
        @click="zzzs_show = true"
        label="是否需要纸质证书"
        v-model="zzzs_picker[submit_form.zzzs_index]"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />

      <div class="pl16 pb10 fz12" v-if="submit_form.zzzs_index == 1">
        票据原则上自取，地址：上海市宝山区友谊支路238号；单笔捐款金额满200元可邮寄票据。
      </div>

      <van-popup v-model="zzzs_show" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="zzzs_picker"
          @cancel="zzzs_show = false"
          @confirm="
            (item, index) => {
              this.submit_form.zzzs_index = index
              this.zzzs_show = false
            }
          "
        />
      </van-popup>

      <!-- 是否实名公开 -->
      <van-field
        required
        @click="is_real_name_show = true"
        label="是否实名公开"
        v-model="is_real_name_picker[submit_form.is_real_name]"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />

      <div
        class="pl16 pb10 fz12"
        v-if="submit_form.is_real_name === 0 && submit_form.jkfs_index == 0"
      >
        公示栏中,以“爱心人士”称呼
      </div>
      <div
        class="pl16 pb10 fz12"
        v-if="submit_form.is_real_name === 0 && submit_form.jkfs_index == 1"
      >
        公示栏中，以“爱心单位”称呼
      </div>

      <van-popup v-model="is_real_name_show" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="is_real_name_picker"
          @cancel="is_real_name_show = false"
          @confirm="
            (item, index) => {
              this.submit_form.is_real_name = index
              this.is_real_name_show = false
            }
          "
        />
      </van-popup>

      <!-- 是否要收据 -->
      <van-field
        required
        @click="is_receipt_show = true"
        label="是否需要收据"
        v-model="is_receipt_picker[submit_form.is_receipt]"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />

      <div v-if="submit_form.is_receipt == 1" class="pl16 pb10 fz12">
        票据为自取方式，取票地址为上海市宝山区友谊支路238号，要求捐赠之日起一个月之内须领取
      </div>
      <div v-if="submit_form.is_receipt === 0" class="pl16 pb10 fz12">
        本会将根据自然月的捐款类别进行合并开具捐赠统一票据。一旦确定不得更改。
      </div>
      <van-popup v-model="is_receipt_show" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="is_receipt_picker"
          @cancel="is_receipt_show = false"
          @confirm="
            (item, index) => {
              this.submit_form.is_receipt = index
              this.is_receipt_show = false
            }
          "
        />
      </van-popup>
      <van-field
        v-if="submit_form.jkfs_index == 1"
        label="单位名称"
        v-model="submit_form.company_name"
        placeholder="单位名称"
        input-align="right"
      />

            <van-field
        v-if="submit_form.is_receipt == 1"
        label="收据抬头"
        v-model="submit_form.receipt_company_name"
        placeholder="收据抬头"
        input-align="right"
      />

      <van-field
        required
        label="联系人"
        v-model="submit_form.username"
        placeholder="联系人"
        input-align="right"
      />

      <van-field
        required
        label="手机"
        v-model="submit_form.mobile"
        placeholder="手机"
        input-align="right"
      />
      <van-field
        label="座机"
        v-model="submit_form.tel"
        placeholder="座机"
        input-align="right"
      />
      <van-field
        label="联系地址"
        v-model="submit_form.contact_address"
        placeholder="联系地址"
        input-align="right"
      />
      <van-field
        label="电子邮箱"
        v-model="submit_form.email"
        placeholder="电子邮箱"
        input-align="right"
      />
      <van-field
        label="支付方式"
        value="微信支付"
        placeholder="请选择"
        input-align="right"
        readonly
        clickable
      />
    </van-cell-group>

    <van-popup class="confirm-money-dialog" v-model="confirm_money_show">
      <div class="fc ja ac" style="height: 100%">
        <input
          style="width: 227px; margin-top: 57px; text-align: center"
          v-model="submit_form.money2"
          class="p10"
          type="text"
          placeholder="请再次输入金额"
        />
        <van-button
          type="danger"
          size="small"
          @click="confirmMoney2"
          class="mt20"
          >确认</van-button
        >
      </div>
    </van-popup>

    <div class="fr jc ac p30">
      <van-button block type="danger" @click="submit">确定</van-button>
    </div>
    <van-dialog
      class="dialog"
      v-model="is_confirm"
      title
      :overlay="false"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <div class="fc jc ac">
        <div>{{ submit_form.name }}</div>
        <div class="mt30">{{ submit_form.username }}</div>
        <div class="mt30">{{ submit_form.money }}元</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
export default {
  data() {
    return {
      openid: '213',
      //捐款意向
      jkyx_show: false,
      jkyx_picker: [
        { id: 1, name: '意向1' },
        { id: 2, name: '意向2' },
      ],

      // 捐款金额
      jkje_show: false,
      jkje_picker: ['5元', '10元', '50元', '其他金额'],
      //确认金额
      confirm_money_show: false,

      //是否需要纸质证书
      zzzs_show: false,
      zzzs_picker: ['否', '是'],

      //捐款方式
      jkfs_show: false,
      jkfs_picker: ['个人', '单位'],
      //   是否实名
      is_real_name_show: false,
      is_real_name_picker: ['否', '是'],
      //是否要收据
      is_receipt_show: false,
      is_receipt_picker: ['否', '是'],
      //提交表单

      submit_form: {
        //捐款意向
        name: '',
        //   捐款意向 index
        jkyx_index: '',
        //捐款金额 index
        jkje_index: '',
        zzzs_index: '',
        //捐款方式(个人,单位) index
        jkfs_index: '',
        //是否实名公开
        is_real_name: '',
        //是否要收据
        is_receipt: '',
        //个人名称
        username: '',
        //单位名称
        company_name: '',
        //手机
        mobile: '',
        //座机
        tel: '',
        //联系地址
        contact_address: '',
        //邮箱
        email: '',
        //捐款金额
        money: '',
        money2: '',
      },
      //是否确认
      is_confirm: false,
    }
  },
  mounted() {
    // this.payMent()
    //  console.log("跳转授权")

    if (this.$route.query.code) {
      this.getOpenId(this.$route.query.code)
    }

    if (this.$route.query.param) {
      let param = JSON.parse(this.$route.query.param)
      if (param) {
        this.submit_form = param
        this.openid = param.openid
      }
    }

    this.getContributeProjectList()
  },
  methods: {
    onMoneyInput() {
      if (
        this.submit_form.money >= 1000 &&
        this.submit_form.money != this.submit_form.money2
      ) {
        console.log('显示弹窗')
        this.confirm_money_show = true
        return
      }
    },
    // 获取openid
    getOpenId(code) {
      let param = {
        code: code,
      }
      this.post('wx/getOpenid', param).then((res) => {
        this.openid = res.data
      })
    },

    confirmMoney2() {
      if (this.submit_form.money == this.submit_form.money2) {
        this.confirm_money_show = false
      } else {
        Toast('两次金额不一致')
        return
      }
    },
    //获取捐款项目列表
    getContributeProjectList() {
      this.post('contributeMoney/getContributeProjectList').then((res) => {
        this.jkyx_picker = res.data
      })
    },

    submit() {
      let param = Object.assign({}, this.submit_form)

      if (!param.name) {
        Toast('选择捐款意向')
        return
      }

      if (param.jkfs_index === '') {
        Toast('选择捐款方式')
        return
      }
      if (param.money < 0.01) {
        Toast('捐款金额需大于0.01元')
        return
      }

      if (param.is_real_name === '') {
        Toast('选择是否实名公开')
        return
      }
      if (param.is_receipt === '') {
        Toast('选择是否需要收据')
        return
      }

      if (!param.username) {
        Toast('请填写联系人')
        return
      }

      if (param.mobile.length != 11) {
        Toast('请填写正确的联系电话')
        return
      }

      param.con_project_id = this.jkyx_picker[this.submit_form.jkyx_index].id
      param.con_type = this.submit_form.jkfs_index
      param.is_paper = this.submit_form.zzzs_index
      param.openid = this.openid

      if (!param.openid) {
        Toast('openid为空,请退出重新进入')
        return
      }
      this.$router.push({
        path: '/contributeMoney/next',
        query: {
          param: JSON.stringify(param),
        },
      })
    },
  },
}
</script>
<style lang="less" scoped>
.confirm-money-dialog {
  width: 346px;
  height: 206px;
  border-radius: 10px;
}
.pl16 {
  padding-left: 16px;
  color: #808080;
}
/deep/ .van-cell {
  // border-top: 1px solid #ebedf0;
  border: none;
  border-top: 1px solid #ebedf0;
}
/deep/ .van-cell:not(:last-child)::after {
  border: none;
}
.dialog {
  width: 100vw;
  height: 100vh;
}
/deep/.van-dialog {
  width: 100vw;
  height: 100vh;
  top: 0;
}
/deep/ .van-field__label {
  width: 150px;
}
</style>